<template>
    <div v-if="selectedProduct" class="products-spec">
      <transition name="fade" mode="out-in">
        <svg class="bg-circle" :key="selectedProduct.url + '-svg'" version="1.1"
            xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
            x="0px" y="0px" width="157.2px" height="157.2px" viewBox="0 0 157.2 157.2" style="enable-background:new 0 0 157.2 157.2;"
            xml:space="preserve">
        <svg:style type="text/css">
            .st0{fill:#F8FAFC;}
        </svg:style>
        <defs>
        </defs>
        <circle class="st0" cx="78.6" cy="78.6" r="78.6"/>
        </svg>
      </transition>
      <transition :name="slideDirection + '-first'" mode="out-in">
        <div class="products-spec-info"  :key="selectedProduct.url + '-info'">
            <h1>{{selectedProduct.title}}</h1>
            <p>{{selectedProduct.description}}</p>
            <div class="products-spec-rows">
                <div v-for="(row,index) in selectedProduct.tables" :key="index">
                    <h6>{{row.title}}</h6>
                    <div v-for="(cell, index) in row.cells" :key="index" class="products-spec-row">
                        <p>{{cell[0]}}</p>
                        <p>{{cell[1]}}</p>
                    </div>
                    <div class="colors">
                        <div v-for="(cell, index) in row.colors" :key="index" class="products-spec-row products-spec-colors" :style="{backgroundColor: cell[1]}">
                            <p>{{cell[0]}}</p>
                        </div>
                    </div>
                </div>
            </div>
            <p v-if="selectedProduct.texts" v-for="(text, index) in selectedProduct.texts" :key="'text-' + index">{{text}}</p>
            <p v-if="selectedProduct.link">
              <a :href="selectedProduct.link[0]" target="_blank">{{selectedProduct.link[1]}}</a>
            </p>
            <p v-if="selectedProduct.lastText" class="margin-top-15">{{selectedProduct.lastText}}</p>
            <p class="margin-top-15">Find your <router-link to="/contacts/sales-department">contact</router-link> or send us your <a href="mailto:sales@alcomet.eu">enquiry</a>.</p>
        </div>
      </transition>
      <transition :name="slideDirection + '-second'" mode="out-in">
        <div class="products-spec-preview" v-if="selectedProduct.images" :key="selectedProduct.url + '-image'">
          <div class="procucts-spec-image-container">
            <transition-group mode="out-in" :name="slideDirection">
              <div v-if="index == activeImage" v-for="(image, index) in selectedProduct.images" :key="index" class="products-spec-preview-img" :style="{backgroundImage: 'url(' + image + ')'}"></div>
            </transition-group>
          </div>
        </div>
      </transition>
      <div class="products-spec-preview-controlls">
        <div title="Previous product" class="products-spec-preview-controll" @click="prevProduct()">
            <span class="alcomet">M</span>
        </div>
        <!-- <div class="products-spec-preview-controll" @click="isGalleryOpened = true">
            <span class="alcomet">S</span>
        </div> -->
        <div title="Next product" class="products-spec-preview-controll" @click="nextProduct()">
            <span class="alcomet">L</span>
        </div>
        <div title="Share" class="products-spec-preview-controll controll-share" :class="{ 'share-expanded' : isShareExpanded }">
            <span v-if="!isShareExpanded" class="alcomet" @click="toggleShare()">F</span>
            <a title="LinkedIn" v-if="isShareExpanded" class="share-a" @click.prevent="shareOnLinkedIn()"><span class="alcomet">C</span></a>
            <a title="Facebook" v-if="isShareExpanded" class="share-a" @click.prevent="shareOnFacebook()"><span class="alcomet">D</span></a>
            <a title="Youtube" v-if="isShareExpanded" class="share-a" @click.prevent="shareOnYoutube()"><span class="alcomet">E</span></a>
            <a title="Instagram" v-if="isShareExpanded" class="share-a" @click.prevent="shareOnInstagram()"><span class="alcomet">B</span></a>
        </div>
        <!--
        <div title="Make an inquiry" class="products-spec-preview-controll inquiry-parent" @click="showInquiry = true">
            <span class="alcomet">Q</span>
            <transition name="inquiry">
            <div class="inquiry-wrapper" v-if="showInquiry">
              <div class="inquiry-form">
                <p>Make an inquiry for the selected product</p>
                <span class="alcomet close-inquiry" @click.stop="showInquiry = false">H</span>
                <span class="alcomet inquiry-top-img">Q</span>
                <input v-model="request.name" class="inquiry-input" :class="{ 'not-valid' : !isNameValid}" type="text" placeholder="Name*">
                <input v-model="request.phone" class="inquiry-input" :class="{ 'not-valid' : !isPhoneValid}" type="text" placeholder="Phone*">
                <input v-model="request.email" class="inquiry-input" :class="{ 'not-valid' : !isEmailValid}" type="text" placeholder="e-mail*">
                <textarea v-model="request.message" placeholder="Message*" class="inquiry-textarea" :class="{ 'not-valid' : !isMessageValid}" cols="30" rows="10"></textarea>
                <a class="contacts-box-btn" @click="sendInquiry()">
                  <transition name="sending" mode="out-in">
                    <span v-if="!isLoading && !isSent">
                      Submit request
                    </span>
                    <div v-else-if="isLoading && !isSent" class="loader">
                      <svg class="loader-svg" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                        width="24px" height="30px" viewBox="0 0 24 30" style="enable-background:new 0 0 50 50;" xml:space="preserve">
                        <rect x="0" y="10" width="4" height="10" fill="#333" opacity="0.2">
                          <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0s" dur="0.6s" repeatCount="indefinite" />
                        </rect>
                        <rect x="8" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                          <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.15s" dur="0.6s" repeatCount="indefinite" />
                        </rect>
                        <rect x="16" y="10" width="4" height="10" fill="#333"  opacity="0.2">
                          <animate attributeName="opacity" attributeType="XML" values="0.2; 1; .2" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="height" attributeType="XML" values="10; 20; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                          <animate attributeName="y" attributeType="XML" values="10; 5; 10" begin="0.3s" dur="0.6s" repeatCount="indefinite" />
                        </rect>
                      </svg>
                    </div>
                    <div v-else-if="isSent">
                      <svg class="sent-svg" aria-hidden="true" data-prefix="fas" data-icon="check" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z"></path></svg>
                    </div>
                  </transition>
                </a>
              </div>
            </div>
            </transition>
        </div>
        -->
      </div>
      <!-- GALLERY -->
      <app-gallery v-if="isGalleryOpened" :picturesArray="selectedProduct.images" :eventName="'close-product-gallery'"></app-gallery>
    </div>
</template>

<script>
import "../../assets/scripts/smtp.js";
import Gallery from "../shared/Gallery";
import Products from "./products.json";
export default {
  components: {
    appGallery: Gallery
  },
  data() {
    return {
      isShareExpanded: false,
      showInquiry: false,
      slideDirection: "slide-down",
      activeImage: 0,
      isGalleryOpened: false,
      products: Products,
      selectedProduct: {},
      previousSelectedIndex: 0,
      // INQUIRY REQUEST SECTION
      // waiting for callback after email is sent
      isLoading: false,
      // got the callback and everything's done
      isSent: false,
      // all input fields are by default true, because if not
      // their bottom border will be red
      isNameValid: true,
      isPhoneValid: true,
      isEmailValid: true,
      isMessageValid: true,
      request: {
        products: "",
        name: "",
        phone: "",
        email: "",
        message: ""
      }
    };
  },
  watch: {
    $route(to, from) {
      this.previousSelectedIndex = this.products.indexOf(this.selectedProduct);
      this.selectedProduct = {};
      this.activeImage = 0;
      this.showInquiry = false;
      this.isShareExpanded = false;
      this.findProduct();
      if (
        this.previousSelectedIndex < this.products.indexOf(this.selectedProduct)
      ) {
        this.slideDirection = "slide-down";
      } else {
        this.slideDirection = "slide-up";
      }
    }
  },
  methods: {
    findProduct() {
      // filtering because IE doesn't recognize the find method
      this.selectedProduct = this.products.filter(p => {
        return (
          p.url == this.$route.params.product &&
          p.category == this.$route.params.category
        );
      })[0];
    },
    prevProduct() {
      const selectedIndex = this.products.indexOf(this.selectedProduct);
      for (let i = selectedIndex; i > 0; i--) {
        if (this.products[i - 1].category === this.$route.params.category) {
          this.$router.replace({
            name: "Products",
            params: {
              page: this.$route.params.category,
              product: this.products[i - 1].url
            }
          });
          break;
        }
      }
    },
    nextProduct() {
      const selectedIndex = this.products.indexOf(this.selectedProduct);
      for (let i = selectedIndex; i < this.products.length - 1; i++) {
        if (this.products[i + 1].category === this.$route.params.category) {
          this.$router.replace({
            name: "Products",
            params: {
              page: this.$route.params.category,
              product: this.products[i + 1].url
            }
          });
          break;
        }
      }
    },
    // prevImage() {
    //   this.slideDirection = "slide-up";
    //   if (this.activeImage > 0) {
    //     this.activeImage--;
    //   } else {
    //     this.activeImage = this.selectedProduct.images.length - 1;
    //   }
    // },
    // nextImage() {
    //   this.slideDirection = "slide-down";
    //   if (this.activeImage < this.selectedProduct.images.length - 1) {
    //     this.activeImage++;
    //   } else {
    //     this.activeImage = 0;
    //   }
    // },
    toggleShare() {
      this.isShareExpanded = true;
    },
    shareOnLinkedIn() {
      this.isShareExpanded = false;
    },
    shareOnFacebook() {
      this.isShareExpanded = false;
    },
    shareOnYoutube() {
      this.isShareExpanded = false;
    },
    shareOnInstagram() {
      this.isShareExpanded = false;
    },
    // INQUIRY STUFF
    toggleInquiry() {
      this.showInquiry = this.showInquiry === false ? true : false;
      console.log(this.showInquiry);
    },
    sendInquiry() {
      if (this.isValid()) {
        this.isLoading = true;
        Email.send(
          "office@alcomet.eu",
          [
            "george.apostolov@alcomet.eu",
            "maya.blaskova@alcomet.eu",
            "p.detchev@cdots.bg",
            "y.andreev@cdots.bg",
            "z.pernikov@cdots.bg"
          ],
          `Запитване за продукт от Alcomet.eu`,
          `
          Здравейте,<br><br>
          Имате ново запитване от Alcomet.eu:<br><br>

          Име: ${this.request.name},<br>
          Телефон: ${this.request.phone},<br>
          E-mail: ${this.request.email},<br>
          Продукт: ${this.selectedProduct.name},<br>
          Въпрос: ${this.request.message},<br><br>

          Това е автоматичен e-mail моля не отговаряйте.
          `,
          {
            token: "f038171e-cd38-4ecf-99bf-c59583653252",
            callback: message => {
              this.request = {
                category: "",
                name: "",
                phone: "",
                email: "",
                message: ""
              };
              this.isSent = true;
              setTimeout(() => {
                this.isLoading = false;
                this.isSent = false;
              }, 3000);
            }
          }
        );
      } else {
        // don't send anything
        setTimeout(() => {
          this.isNameValid = true;
          this.isPhoneValid = true;
          this.isEmailValid = true;
          this.isMessageValid = true;
        }, 2000);
      }
    },
    isValid() {
      if (this.request.name.length < 1 || this.request.name.length > 50) {
        this.isNameValid = false;
      }
      if (this.request.phone.length < 1 || this.request.phone.length > 20) {
        this.isPhoneValid = false;
      }
      if (!this.validateEmail(this.request.email)) {
        this.isEmailValid = false;
      }
      if (
        this.request.message.length < 1 ||
        this.request.message.length > 500
      ) {
        this.isMessageValid = false;
      }
      if (
        !this.isNameValid ||
        !this.isPhoneValid ||
        !this.isEmailValid ||
        !this.isMessageValid
      ) {
        return false;
      }
      return true;
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    }
  },
  mounted() {
    this.findProduct();
    this.$eventHub.$on("close-product-gallery", () => {
      this.isGalleryOpened = false;
    });
  },
  destroyed() {
    this.$eventHub.$off("close-product-gallery");
  }
};
</script>

<style scoped>
.products-spec {
  display: flex;
  position: relative;
  width: 75%;
}
.bg-circle {
  content: "";
  height: 100%;
  left: -10%;
  position: absolute;
  top: 5%;
  width: 100%;
  z-index: -1;
}
/* SPEC INFO */
.products-spec-info {
  width: 45%;
}
.products-spec-info > h1 {
  font-size: 36px;
  margin: 20px 0;
}
.products-spec-info > p {
  font-size: 16px;
  text-align: justify;
  margin-bottom: 15px;
}
.products-spec-rows h6 {
  font-size: 16px;
  margin: 20px 0;
  padding: 0 35px;
}

.products-spec-row {
  align-items: center;
  border-radius: 6px;
  background-color: #428bc7;
  display: flex;
  height: 40px;
  margin: 5px 0;
  padding: 0 35px;
  justify-content: space-between;
}
.colors {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.products-spec-colors {
  display: inline-flex;
  width: 48%;
}
.products-spec-row p {
  color: #fff;
  font-size: 16px;
}
/* IMAGE PREVIEW */
.products-spec-preview {
  align-items: center;
  display: flex;
  justify-content: center;
  position: relative;
  width: 55%;
}
.procucts-spec-image-container {
  height: 100%;
  overflow: hidden;
  position: relative;
  width: 60%;
}
.products-spec-preview-img {
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  width: 100%;
  height: 75%;
  position: absolute;
  top: 12.5%;
}
.products-spec-preview-controlls {
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  /* position: absolute; */
  margin-right: 50px;
  margin-top: 5%;
  right: 100px;
  top: 0;
}
.products-spec-preview-controll {
  align-items: center;
  border: 1px solid #dde7ee;
  border-radius: 25px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  height: 50px;
  justify-content: center;
  margin: 5px 0;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 50px;
}
.products-spec-preview-controll:hover {
  background-color: #dde7ee;
}
.products-spec-preview-controll > span {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
}
.share-expanded {
  height: 188px;
  /* padding: 2px; */
  justify-content: space-between;
}
.share-expanded:hover {
  background: transparent;
}
.share-a {
  align-items: center;
  display: flex;
  justify-content: center;
  width: 100%;
  height: 25%;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.share-a:first-child {
  border-top-left-radius: 50%;
  border-top-right-radius: 50%;
}
.share-a:last-child {
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
}
.share-a:hover {
  background-color: #dde7ee;
}
/* INQUIRY */
.inquiry-parent {
  position: relative;
}
.inquiry-wrapper {
  background-color: rgba(237, 242, 244, 0.98);
  border-radius: 6px;
  -webkit-box-shadow: 0px 29px 59px 0px rgba(51, 58, 69, 0.36);
  -moz-box-shadow: 0px 29px 59px 0px rgba(51, 58, 69, 0.36);
  box-shadow: 0px 29px 59px 0px rgba(51, 58, 69, 0.36);
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 140%;
  top: 50%;
  transform: translateY(-50%);
  width: 320px;
}
.inquiry-form {
  overflow: hidden;
  padding: 25px;
  position: relative;
  width: 100%;
}

.inquiry-form > p {
  font-size: 16px;
  line-height: 24px;
  margin-bottom: 15px;
  width: 70%;
}
.inquiry-wrapper::after {
  border-bottom: 10px solid transparent;
  border-left: 10px solid rgba(237, 242, 244, 0.98);
  border-top: 10px solid transparent;
  content: "";
  height: 0;
  right: -10px;
  position: absolute;
  top: calc(50% - 10px);
  width: 0;
}
.close-inquiry {
  align-items: center;
  border-top-right-radius: 6px;
  color: #c5d7e4;
  cursor: pointer;
  display: flex;
  font-size: 16px;
  height: 30px;
  justify-content: center;
  position: absolute;
  right: 10px;
  top: 10px;
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
  width: 30px;
}
.close-inquiry:hover {
  background-color: #c5d7e4;
  color: #fff;
}
.inquiry-top-img {
  color: #05345e;
  font-size: 130px;
  left: -15px;
  opacity: 0.07;
  position: absolute;
  top: 0;
}
.inquiry-input {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #c5d7e4;
  font-weight: 500;
  height: 32px;
  padding: 0 10px;
  margin-top: 15px;
  position: relative;
  width: 100%;
  z-index: 1;
}
.inquiry-textarea {
  background-color: transparent;
  border: 0;
  border-bottom: 1px solid #c5d7e4;
  font-size: 14px;
  font-weight: 500;
  height: 100px;
  margin-top: 15px;
  padding: 10px;
  width: 100%;
  resize: none;
}
.inquiry-input:-moz-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-input::-moz-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-input:-ms-input-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-input::-webkit-input-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-textarea:-moz-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-textarea::-moz-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-textarea:-ms-input-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.inquiry-textarea::-webkit-input-placeholder {
  color: #004787;
  font-size: 14px;
  font-weight: 500;
}
.not-valid {
  border-bottom: 1px solid red;
}
.contacts-box-btn {
  align-items: center;
  border: 1px solid #588cc1;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 500;
  margin: 25px 0 5px;
  display: flex;
  justify-content: center;
  padding: 7px;
  width: 100%;
}
.contacts-box-btn:hover {
  background-color: #dde7ee;
}
.loader {
  height: 16px;
  display: inline-block;
  text-align: center;
}
.loader-svg {
  height: 16px;
}
.sent-svg {
  height: 12px;
}
svg path,
svg rect {
  fill: #004787;
}
.margin-top-15 {
  margin-top: 15px;
}
/* TRANSITIONS */
.slide-up-first-enter-active,
.slide-down-first-enter-active {
  transition: all 0.6s ease;
}
.slide-up-first-leave-active,
.slide-down-first-leave-active {
  transition: all 0.4s ease;
}
.slide-up-first-enter,
.slide-down-first-leave-to,
.slide-up-second-enter,
.slide-down-second-leave-to {
  transform: translateY(-100%);
  opacity: 0;
}
.slide-up-first-leave-to,
.slide-down-first-enter,
.slide-up-second-leave-to,
.slide-down-second-enter {
  transform: translateY(100%);
  opacity: 0;
}
.slide-up-second-enter-active,
.slide-down-second-enter-active {
  transition: all 0.6s ease;
  transition-delay: 0.1s;
}
.slide-up-second-leave-active,
.slide-down-second-leave-active {
  transition: all 0.4s ease;
  transition-delay: 0.1s;
}
.fade-enter-active,
.fade-leave-active {
  transition: all 0.4s ease;
}
.fade-leave-to,
.fade-enter {
  opacity: 0;
}
.inquiry-enter-active,
.inquiry-leave-active {
  transition: all 0.4s ease;
}
.inquiry-leave-to,
.inquiry-enter {
  opacity: 0;
  transform: translateX(15px) translateY(-50%);
}
.sending-enter-active,
.sending-leave-active {
  -webkit-transition: all 0.2s ease;
  -moz-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  -o-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.sending-enter {
  opacity: 0;
  transform: translateX(100%);
}
.sending-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}
@media screen and (max-width: 1440px) {
  .products-spec-info {
    width: 45%;
  }
  .products-spec-preview {
    width: 55%;
  }
}
@media screen and (max-width: 1280px) {
  .products-spec-info > h1 {
    font-size: 18px;
  }
  .products-spec-info > p,
  .products-spec-rows h6,
  .products-spec-row p {
    font-size: 14px;
  }
  .products-spec {
    padding: 0 30px;
    width: 75%;
    flex-direction: column;
  }
  .products-spec-info {
    width: 100%;
  }
  .products-spec-preview {
    width: 100%;
  }
  .procucts-spec-image-container {
    height: 45vw;
  }
  .products-spec-preview-controlls {
    flex-direction: row;
    justify-content: center;
    margin: 0;
    width: 100%;
  }
  .products-spec-preview-controll {
    margin: 5px 10px;
  }
  .controll-share {
    display: none;
  }
  .share-expanded {
    flex-direction: row;
    height: 50px;
    width: 188px;
  }
  .share-a {
    height: 100%;
    width: 25%;
  }
  .share-a:first-child {
    border-top-right-radius: 0;
    border-bottom-left-radius: 50%;
  }
  .share-a:last-child {
    border-bottom-left-radius: 0;
    border-top-right-radius: 50%;
  }
  .inquiry-wrapper {
    border-radius: 0;
    height: 100vh;
    justify-content: center;
    left: 0;
    position: fixed;
    right: initial;
    top: 0;
    transform: translateY(0);
    width: 100%;
    z-index: 10;
  }
  .inquiry-form {
    height: 100%;
    justify-content: space-around;
    display: flex;
    flex-direction: column;
  }
}
@media screen and (max-width: 1000px) {
  .products-spec {
    width: 100%;
  }
  .procucts-spec-image-container {
    width: 100%;
    height: 100vw;
  }
  .products-spec-preview-img {
    height: 100%;
    top: 0;
  }
}
@media screen and (max-width: 600px) {
  .products-spec-row,
  .products-spec-rows h6 {
    padding: 0 15px;
  }
  .products-spec-row > p {
    font-size: 12px;
  }
}
@media screen and (max-width: 440px) {
  .products-spec-preview-controll {
    height: 40px;
    width: 40px;
  }
  .share-expanded {
    width: 150px;
  }
}
@media screen and (max-width: 380px) {
  .products-spec-row > p {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/products/Specification.vue